import { Pipe, PipeTransform } from '@angular/core';

import { Moment, isMoment } from 'moment';
import moment from 'moment';

@Pipe({ name: 'formatDate' })
/**
 * Pipe to format a date string or Moment object to a specific format.
 * @param value string or Moment object
 * @param format string format for the date (default 'MMM DD, YYYY')
 * @returns formatted date string or null if the date is invalid
 */
export class FormatDatePipe implements PipeTransform {
  transform(value: string | Moment, format: string = 'MMM DD, YYYY'): any {
    let date: Moment;

    if (isMoment(value)) {
      date = value;
    } else if (typeof value === 'string') {
      date = moment(value);
    }

    if (date && date.isValid()) {
      return date.format(format);
    }
    return null;
  }
}
